// Admin CMS

import React, { useEffect, useState } from "react";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import AddButton from "../../../../reusable-components/buttons/AddButton";
import H2withIcon from "../../../../reusable-components/headings/H2withIcon";
import SpinnerWithText from "../../../../reusable-components/loader/SpinnerWithText";
import { IconContext } from "react-icons";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { LEGAL_NOTICE_CONFIG_URL } from "../../../../api/api_routing_urls";
import { ToastContainer } from "react-toastify";
import showToast from "../../../../utilities/notification/NotificationModal";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import ContainerShadow from "../../../../reusable-components/containers/ContainerShadow";
import AddLegalNotice from "./addLegalNotice.component";
// import useAuth from "../../../../authentication/hooks/useAuth";

const LegalNoticeAdmin = () => {
  // const { auth } = useAuth();

  const [showAddForm, setShowAddForm] = useState(false);
  const [legalNotice, setLegalNotice] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // const axiosPrivate = useAxiosPrivate();

  const isEdit =
    legalNotice !== undefined ? Object.keys(legalNotice).length > 0 : false;

  const getLegalNoticeDetails = async () => {
    try {
      const response = await axios.get(LEGAL_NOTICE_CONFIG_URL);

      // let sanitized = "";
      // if (response.data.aboutUsDetails?.aboutuscontent !== undefined) {
      //   sanitized = sanitizeHtml(response.data.aboutUsDetails.aboutuscontent);
      //   response.data.aboutUsDetails.aboutuscontent = sanitized;
      // }
      response.status === 200 &&
        setLegalNotice(response?.data?.legalNoticeDetails);
      response.status === 202 &&
        showToast("Legal Notice details not found in the system.", "error");
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    isMounted && getLegalNoticeDetails();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Dashboard>
      <ToastContainer />
      <div className="flex items-center justify-between">
        <H2withIcon>
          <IconContext.Provider value={{ className: "text-black" }}>
            <BsFillInfoCircleFill />
          </IconContext.Provider>
          &nbsp; Legal Notice
        </H2withIcon>
        {!showAddForm && (
          <AddButton
            label={`${isEdit ? "Update Legal Notice" : "Add Legal Notice"}`}
            onclick={() => setShowAddForm(true)}
          />
        )}
      </div>
      {showAddForm ? (
        <AddLegalNotice
          getLegalNoticeDetails={getLegalNoticeDetails}
          legalNotice={legalNotice}
          setLegalNotice={setLegalNotice}
          setShowAddForm={setShowAddForm}
        />
      ) : (
        <ContainerShadow>
          {!isEdit ? (
            <p>Legal Notice content yet to be added!</p>
          ) : (
            <div>
              <br />
              <label>
                Legal Notice:
                <br />
              </label>
              <div
                dangerouslySetInnerHTML={{
                  __html: legalNotice.legal_notice_content,
                }}
              />
            </div>
          )}
        </ContainerShadow>
      )}
    </Dashboard>
  );
};

export default LegalNoticeAdmin;
